import { create } from 'zustand';

interface DonorData {
    donorData: {
        currency: string;
        frequency: string;
        amount: number;
        payment: string;
    };
    setDonorData: (params: {
        amount?: number;
        frequency?: string;
        payment?: string;
    }) => void;
    // savedFormFields: {
    //     frequencyField: string;
    //     amountField: string;
    // };
    // setSavedFormField: (params: {
    //     frequencyField?: string;
    //     amountField?: string;
    // }) => void;
}

export const useDonorData = create<DonorData>(set => {
    return {
        donorData: {
            currency: 'AUD',
            amount: 0,
            frequency: 'monthly',
            payment: '',
        },
        setDonorData: ({ amount, frequency, payment }): void => {
            set(state => {
                return {
                    donorData: {
                        ...state.donorData,
                        ...(amount && { amount }),
                        ...(frequency && { frequency }),
                        ...(payment && { payment }),
                    },
                };
            });
        },
    };
});

